module.exports = __webpack_public_path__ + "img/inktober_2020_28_float.0fd29a10.jpg";